export default [
    // 경비현황
    {
        path: '/mng/costStat',
        name: 'CostStat',
        component: () => import('@/views/busi/mng/CostStat.vue')
    },
    // 경비 검색조건
    {
        path: '/mng/costStat/searchCondition',
        name: 'CostSearchCondition',
        component: () => import('@/views/busi/mng/CostSearchCondition.vue')
    },
    // 경비내역
    {
        path: '/mng/costSave',
        name: 'CostSave',
        component: () => import('@/views/busi/mng/CostSave.vue')
    },
    // 경비상세
    {
        path: '/mng/costDetl',
        name: 'CostDetl',
        component: () => import('@/views/busi/mng/CostDetl.vue')
    },

    // 휴가현황
    {
        path: '/mng/vacaStat',
        name: 'VacaStat',
        component: () => import('@/views/busi/mng/VacaStat.vue')
    },
    // 휴가상세
    {
        path: '/mng/vacaDetl',
        name: 'VacaDetl',
        component: () => import('@/views/busi/mng/VacaDetl.vue')
    },
    // 휴가신청
    {
        path: '/mng/vacaSave',
        name: 'VacaSave',
        component: () => import('@/views/busi/mng/VacaSave.vue')
    },
    // 일정관리
    {
        path: '/mng/SchdStat',
        name: 'SchdStat',
        component: () => import('@/views/busi/mng/SchdStat.vue')
    },
    //일정현황
    {
        path: '/mng/SchdList',
        name: 'SchdList',
        component: () => import('@/views/busi/mng/SchdList.vue'),
    },
    //일정등록
    {
        path: '/mng/SchdSave',
        name: 'SchdSave',
        component: () => import('@/views/busi/mng/SchdSave.vue'),
    },
    //출퇴근관리 (달력)
    {
        path: '/mng/AttdLvMng',
        name: 'AttdLvMng',
        component: () => import('@/views/busi/mng/AttdLvMng.vue'),
    },
    //출퇴근 저장 화면
    {
        path: '/mng/AttdLvSave',
        name: 'AttdLvSave',
        component: () => import('@/views/busi/mng/AttdLvSave.vue'),
    },
    //출퇴근 수정 화면
    {
        path: '/mng/AttdLvModify',
        name: 'AttdLvModify',
        component: () => import('@/views/busi/mng/AttdLvModify.vue'),
    },
    // 휴가승인관리
    {
        path: '/mng/vacaAprvMng',
        name: 'VacaAprvMng',
        component: () => import('@/views/busi/mng/VacaAprvMng.vue'),
    },
    // 휴가승인현황
    {
        path: '/mng/vacaAprvStat',
        name: 'VacaAprvStat',
        component: () => import('@/views/busi/mng/VacaAprvStat.vue'),
    }
]